import { useMemo } from "react";
import { useBusinessExperiments } from ".";
import { CorpBusinessExperimentsMap } from "../types";

export const useBusinessExperimentsById = <
  T extends keyof CorpBusinessExperimentsMap
>(
  id: T
): CorpBusinessExperimentsMap[T] | undefined => {
  const { experiments } = useBusinessExperiments();

  return useMemo(() => experiments[id], [experiments, id]);
};
